__turbopack_context__.v({
  "actions": "CallToCTA-module__6ytTaq__actions",
  "container": "CallToCTA-module__6ytTaq__container",
  "content": "CallToCTA-module__6ytTaq__content",
  "iconBars": "CallToCTA-module__6ytTaq__iconBars",
  "text": "CallToCTA-module__6ytTaq__text",
  "title": "CallToCTA-module__6ytTaq__title",
});
